import { render, staticRenderFns } from "./AccountStatus.vue?vue&type=template&id=27148b62&scoped=true"
import script from "./AccountStatus.vue?vue&type=script&lang=js"
export * from "./AccountStatus.vue?vue&type=script&lang=js"
import style0 from "./AccountStatus.vue?vue&type=style&index=0&id=27148b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27148b62",
  null
  
)

export default component.exports